module.exports = __webpack_public_path__ + "static/media/illust_liveview_coffee_list.80b397f9.svg";